import e from "react";
import R from "classnames";
import { S as c } from "./ShimmerBlock-hNiBn9_0.es.js";
import { u as A } from "./DarkModeProvider-xoZXm3ct.es.js";
import { B as _ } from "./Badge-Cmh6jfGq.es.js";
import { B as k } from "./Body-DdQfpamO.es.js";
import { F as b } from "./FooterLabel-CGWdiGCg.es.js";
import { I as g } from "./Icon-CrKtM1fd.es.js";
import { I as p } from "./IconButton-BQZADaee.es.js";
import { I as L } from "./Image-BGpNe79q.es.js";
import { g as M, L as u } from "./Link-Dn-j9GnZ.es.js";
import { T as f } from "./Title-BM-whB_1.es.js";
import './ListCard.css';const V = "ListCard-module__container___PUybi", T = "ListCard-module__clickable___qdPop", x = "ListCard-module__dark___mnxF9", z = "ListCard-module__last___UCZFD", H = "ListCard-module__loading___oyMIi", q = "ListCard-module__loadingRectangles___dxKSz", D = "ListCard-module__block1___G7mnz", K = "ListCard-module__block2___Epk0O", O = "ListCard-module__block3___9VbuZ", P = "ListCard-module__block4___zXLKC", U = "ListCard-module__leftSection___JQqV2", Z = "ListCard-module__middleSection___H67fV", w = "ListCard-module__rightSection___HnfMk", G = "ListCard-module__badgesAndLabels___c1rNm", J = "ListCard-module__links___eOsR8", t = {
  container: V,
  clickable: T,
  dark: x,
  last: z,
  loading: H,
  loadingRectangles: q,
  block1: D,
  block2: K,
  block3: O,
  block4: P,
  leftSection: U,
  middleSection: Z,
  rightSection: w,
  badgesAndLabels: G,
  links: J
}, Q = () => /* @__PURE__ */ e.createElement("div", { className: t.loading }, /* @__PURE__ */ e.createElement(c, { className: t.block1 }), /* @__PURE__ */ e.createElement("div", { className: t.loadingRectangles }, /* @__PURE__ */ e.createElement(c, { className: t.block2 }), /* @__PURE__ */ e.createElement(c, { className: t.block3 }), /* @__PURE__ */ e.createElement(c, { className: t.block4 }))), a = ({
  children: C,
  loading: r = !1,
  isLast: E = !1
}) => {
  const m = e.Children.toArray(C), l = (o) => m.find(
    (n) => e.isValidElement(n) && n.type === o
  ), i = (o) => m.filter(
    (n) => e.isValidElement(n) && n.type === o
  ), S = i(_), N = l(k), I = i(b), y = l(g), B = l(p), d = l(L), v = i(u), s = l(f), h = A(), F = M(
    s?.props?.openInNewTab,
    s?.props?.onClick,
    s?.props?.href
  );
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ e.createElement(
      "li",
      {
        className: R([
          t.container,
          h && t.dark,
          E && t.last,
          s?.props?.onClick && t.clickable
        ]),
        "aria-live": "polite",
        "aria-busy": r ? "true" : "false",
        onClick: F
      },
      r ? /* @__PURE__ */ e.createElement(Q, null) : /* @__PURE__ */ e.createElement(e.Fragment, null, d && /* @__PURE__ */ e.createElement("div", { className: t.leftSection }, d), /* @__PURE__ */ e.createElement("div", { className: t.middleSection }, s, N, /* @__PURE__ */ e.createElement("div", { className: t.badgesAndLabels }, S.map((o) => o), I.map((o) => o)), /* @__PURE__ */ e.createElement("div", { className: t.links }, v.map((o) => o))), /* @__PURE__ */ e.createElement("div", { className: t.rightSection }, B || y))
    )
  );
};
a.Badge = _;
a.Body = k;
a.FooterLabel = b;
a.Icon = g;
a.IconButton = p;
a.Image = L;
a.Link = u;
a.Title = f;
export {
  a as L
};
